import { z } from 'zod';

// 利用規約同意フォームのバリデーションスキーマ
export const termsAgreementSchema = z.object({
  agreed: z.boolean().refine((val) => val === true, {
    message: '利用規約に同意してください',
  }),
});
